const navConfigB2B = [
  {
    label: "關於水禾",
    EN: "SEHO",
    JP: "企業情報",
    href: "/關於水禾",
    children: [
      {
        label: "公司介紹",
        EN: "Profile",
        JP: "会社概要",
        href: "/公司簡介",
      },
      {
        label: "企業理念 & 願景",
        EN: "Vision & Philosophy",
        JP: "企業願景 & 理念",
        href: "/企業理念",
      },
      {
        label: "品牌資訊",
        EN: "Brands",
        JP: "ブランド情報",
        href: "/品牌資訊",
      },
      {
        label: "企業責任(永續發展ESG)",
        EN: "Corporate Responsibility / ESG",
        JP: "ESG経営で、未来へ貢献",
        href: "/企業責任",
      },
    ],
  },
  {
    label: "商品資訊",
    EN: "Product",
    JP: "商品情報",
    href: "/商品資訊",
    children: [
      {
        label: "全站產品",
        EN: "All Products",
        JP: "全製品",
        href: "/商品資訊/",
      },
      // {
      //   label: "新商品",
      //   EN: "New Products",
      //   JP: "新製品",
      //   href: "/商品資訊/新商品",
      // },
      {
        label: "產業類別",
        EN: "Industry Categories",
        JP: "業種から探す",
        href: "/商品資訊/產業類別",
        login: "required",
      },
      {
        label: "人體接觸",
        EN: "Body Contact",
        JP: "身体の部位から探す",
        href: "/商品資訊/人體接觸",
        children: [
          {
            label: "頭",
            EN: "Head",
            JP: "頭部",
            href: "/商品資訊/人體接觸/頭",
            children: [
              {
                label: "髮帽",
                EN: "Hair Caps",
                JP: "ヘアキャップ",
                href: "/商品資訊/人體接觸/頭",
                children: [],
              },
              {
                label: "護目鏡",
                EN: "Goggles",
                JP: "ゴーグル",
                href: "/商品資訊/人體接觸/頭",
                children: [],
              },
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href: "/商品資訊/人體接觸/頭",
                children: [],
              },
            ],
          },
          {
            label: "手",
            EN: "Hands",
            JP: "手",
            href: "/商品資訊/人體接觸/手",
            children: [
              {
                label: "手套",
                EN: "Gloves",
                JP: "手袋",
                href: "/商品資訊/人體接觸/手/手套",
                children: [
                  {
                    label: "NBR手套",
                    EN: "NBR Gloves",
                    JP: "NBR手袋",
                    href: "/商品資訊/人體接觸/手/手套/NBR手套",
                  },
                  {
                    label: "PVC手套",
                    EN: "PVC Gloves",
                    JP: "PVC手袋",
                    href: "/商品資訊/人體接觸/手/手套/PVC手套",
                  },
                  {
                    label: "防切割手套",
                    EN: "Cut-resistant Gloves",
                    JP: "耐切創手袋",
                    href: "/商品資訊/人體接觸/手/手套/防切割手套",
                  },
                ],
              },
              {
                label: "袖套",
                EN: "Sleeve Covers",
                JP: "アームカバー",
                href: "/商品資訊/人體接觸/手/袖套",
                children: [],
              },
              {
                label: "手部清潔",
                EN: "Hand Hygiene",
                JP: "手指衛生",
                href: "/商品資訊/人體接觸/手/手部清潔",
                children: [
                  {
                    label: "洗手液/消毒液",
                    EN: "Hand Soap / Disinfectant",
                    JP: "手洗い用石けん／消毒液",
                    href: "/商品資訊/人體接觸/手/手部清潔/洗手液|消毒液",
                  },
                  {
                    label: "手部清潔刷",
                    EN: "Hand Cleaning Brush",
                    JP: "手洗い用ブラシ",
                    href: "/商品資訊/人體接觸/手/手部清潔/手部清潔刷",
                  },
                ],
              },
            ],
          },
          {
            label: "身體",
            EN: "Body",
            JP: "体",
            href: "/商品資訊/人體接觸/身體",
            children: [
              {
                label: "除塵黏紙",
                EN: "Dust-removal Adhesive Sheets",
                JP: "除塵粘着シート",
                href: "/商品資訊/人體接觸/身體/除塵黏紙",
              },
              {
                label: "工作服",
                EN: "Workwear",
                JP: "作業服",
                href: "/商品資訊/人體接觸/身體/工作服",
              },
              {
                label: "防護服",
                EN: "Protective Clothing",
                JP: "防護服",
                href: "/商品資訊/人體接觸/身體/防護服",
              },
            ],
          },
          {
            label: "腳",
            EN: "Feet",
            JP: "足元",
            href: "/商品資訊/人體接觸/腳",
            children: [
              {
                label: "工作鞋/防滑鞋",
                EN: "Work / Anti-slip Shoes",
                JP: "作業靴／滑り止め靴",
                href: "/商品資訊/人體接觸/腳/工作鞋|防滑鞋",
              },
              {
                label: "鞋套",
                EN: "Shoe Covers",
                JP: "シューズカバー",
                href: "/商品資訊/人體接觸/腳/鞋套",
              },
              {
                label: "腳踏黏墊",
                EN: "Adhesive Floor Mats",
                JP: "粘着マット",
                href: "/商品資訊/人體接觸/腳/腳踏黏墊",
              },
            ],
          },
        ],
      },

      {
        label: "使用區域",
        EN: "Application Areas",
        JP: "使用エリア",
        href: "/商品資訊/使用區域",
        children: [
          {
            label: "原料接收區",
            EN: "Receiving Area",
            JP: "原材料受入エリア",
            href: "/商品資訊/使用區域/原料接收區",
            children: [
              {
                label: "防撞桿",
                EN: "Crash Barriers",
                JP: "衝突防止バー",
                href: "/商品資訊/使用區域/原料接收區/防撞桿",
              },
              {
                label: "區域標示",
                EN: "Area Signage",
                JP: "エリア表示",
                href: "/商品資訊/使用區域/原料接收區/區域標示",
              },
              {
                label: "防護邊條",
                EN: "Protective Edge Guards",
                JP: "保護エッジ材",
                href: "/商品資訊/使用區域/原料接收區/防護邊條",
              },
              {
                label: "快速捲門",
                EN: "High-speed Roll-up Doors",
                JP: "高速ロールアップドア",
                href: "/商品資訊/使用區域/原料接收區/快速捲門",
              },
              {
                label: "防蟲門簾",
                EN: "Insect-screen Curtains",
                JP: "防虫カーテン",
                href: "/商品資訊/使用區域/原料接收區/防蟲門簾",
              },
              {
                label: "忌避劑",
                EN: "Insect Repellent",
                JP: "忌避剤",
                href: "/商品資訊/使用區域/原料接收區/忌避劑",
              },
              {
                label: "防蟲/捕蟲燈(捕蟲紙)",
                EN: "Insect Light Traps (Sticky Boards)",
                JP: "防虫／捕虫ライト（粘着シート）",
                href: "/商品資訊/使用區域/原料接收區/防蟲|捕蟲燈(捕蟲紙)",
              },
            ],
          },
          {
            label: "浴塵室",
            EN: "Air Shower",
            JP: "浴場",
            href: "/商品資訊/使用區域/浴塵室",
          },
          {
            label: "原料儲存區",
            EN: "Storage Area",
            JP: "製品保管エリア",
            href: "/商品資訊/使用區域/原料儲存區",
          },
          {
            label: "員工更衣室",
            EN: "Changing Room",
            JP: "更衣室",
            href: "/商品資訊/使用區域/員工更衣室",
            children: [
              {
                label: "髮帽",
                EN: "Hair Caps",
                JP: "ヘアキャップ",
                href: "/商品資訊/使用區域/員工更衣室/髮帽",
              },
              {
                label: "護目鏡",
                EN: "Goggles",
                JP: "ゴーグル",
                href: "/商品資訊/使用區域/員工更衣室/護目鏡",
              },
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href: "/商品資訊/使用區域/員工更衣室/口罩",
              },
              {
                label: "袖套",
                EN: "Sleeve Covers",
                JP: "アームカバー",
                href: "/商品資訊/使用區域/員工更衣室/袖套",
              },
              {
                label: "工作服/防護服",
                EN: "Workwear / Protective Clothing",
                JP: "作業服／防護服",
                href: "/商品資訊/使用區域/員工更衣室/工作服|防護服",
              },
              {
                label: "工作鞋/防滑鞋",
                EN: "Work / Anti-slip Shoes",
                JP: "作業靴／滑り止め靴",
                href: "/商品資訊/使用區域/員工更衣室/工作鞋|防滑鞋",
              },
              {
                label: "鞋套",
                EN: "Shoe Covers",
                JP: "シューズカバー",
                href: "/商品資訊/使用區域/員工更衣室/鞋套",
              },
            ],
          },
          {
            label: "洗手消毒區",
            EN: "Handwashing & Disinfection Area",
            JP: "手洗い・消毒",
            href: "/商品資訊/使用區域/洗手消毒區",
            children: [
              {
                label: "洗手設備(洗手/消毒/乾手)",
                EN: "Handwashing Equipment (Wash / Disinfect / Dry)",
                JP: "手洗い設備（洗浄・消毒・乾燥）",
                href: "/商品資訊/使用區域/洗手消毒區/洗手設備(洗手/消毒/乾手)",
              },
              {
                label: "手部清潔刷具",
                EN: "Hand Cleaning Brushes",
                JP: "手洗い用ブラシ",
                href: "/商品資訊/使用區域/洗手消毒區/手部清潔刷具",
              },
              {
                label: "洗手液",
                EN: "Hand Soap",
                JP: "ハンドソープ",
                href: "/商品資訊/使用區域/洗手消毒區/洗手液",
              },
              {
                label: "消毒液",
                EN: "Disinfectant",
                JP: "消毒液",
                href: "/商品資訊/使用區域/洗手消毒區/消毒液",
              },
              {
                label: "擦手紙",
                EN: "Paper Towels",
                JP: "ペーパータオル",
                href: "/商品資訊/使用區域/洗手消毒區/擦手紙",
              },
              {
                label: "除塵黏紙",
                EN: "Dust-removal Adhesive Sheets",
                JP: "除塵粘着シート",
                href: "/商品資訊/使用區域/洗手消毒區/除塵黏紙",
              },
            ],
          },
          {
            label: "前處理區",
            EN: "Pre-processing Area",
            JP: "前処理エリア",
            href: "/商品資訊/使用區域/前處理區",
            children: [
              {
                label: "擦拭布",
                EN: "Wiping Cloths",
                JP: "ワイピングクロス",
                href: "/商品資訊/使用區域/前處理區/擦拭布",
              },
              {
                label: "刷具",
                EN: "Brushes",
                JP: "ブラシ",
                href: "/商品資訊/使用區域/前處理區/刷具",
              },
              {
                label: "洗手設備",
                EN: "Handwashing Equipment",
                JP: "手洗い設備",
                href: "/商品資訊/使用區域/前處理區/洗手設備",
              },
              {
                label: "消毒設備",
                EN: "Disinfection Equipment",
                JP: "消毒設備",
                href: "/商品資訊/使用區域/前處理區/消毒設備",
              },
              {
                label: "洗蔬果設備",
                EN: "Fruit & Vegetable Washing Equipment",
                JP: "野菜・果物洗浄設備",
                href: "/商品資訊/使用區域/前處理區/洗蔬果設備",
              },
              {
                label: "功能水",
                EN: "Functional Water",
                JP: "機能水",
                href: "/商品資訊/使用區域/前處理区/功能水",
              },
            ],
          },
          {
            label: "加工/烹飪區",
            EN: "Processing / Cooking Area",
            JP: "加工・調理",
            href: "/商品資訊/使用區域/加工|烹飪區",
            children: [
              {
                label: "洗手區",
                EN: "Handwashing Area",
                JP: "手洗いエリア",
                href: "/商品資訊/使用區域/加工|烹飪區/洗手區",
                children: [
                  {
                    label: "洗手設備(洗手/消毒/乾手)",
                    EN: "Handwashing Equipment (Wash / Disinfect / Dry)",
                    JP: "手洗い設備（洗浄・消毒・乾燥）",
                    href: "/商品資訊/使用區域/加工|烹飪區/洗手區/洗手設備(洗手/消毒/乾手)",
                  },
                  {
                    label: "擦手紙",
                    EN: "Paper Towels",
                    JP: "ペーパータオル",
                    href: "/商品資訊/使用區域/加工|烹飪區/洗手區/擦手紙",
                  },
                  {
                    label: "泡沫洗手液",
                    EN: "Foaming Hand Soap ",
                    JP: "泡ハンドソープ ",
                    href: "/商品資訊/使用區域/加工|烹飪區/洗手區/泡沫洗手液",
                  },
                  {
                    label: "酒精除菌劑",
                    EN: "Alcohol Disinfectant ",
                    JP: "アルコール消毒液 ",
                    href: "/商品資訊/使用區域/加工|烹飪區/洗手區/酒精除菌劑",
                  },
                  {
                    label: "中性洗潔精",
                    EN: "Neutral Detergent ",
                    JP: "中性洗剤 ",
                    href: "/商品資訊/使用區域/加工|烹飪區/洗手區/中性洗潔精",
                  },
                  {
                    label: "中性洗潔精",
                    EN: "Neutral Detergent ",
                    JP: "中性洗剤 ",
                    href: "/商品資訊/使用區域/加工|烹飪區/洗手區/中性洗潔精",
                  },
                  {
                    label: "鹼性除菌清潔劑",
                    EN: "Alkaline Antibacterial Cleaner ",
                    JP: "アルカリ性除菌洗浄剤 ",
                    href: "/商品資訊/使用區域/加工|烹飪區/洗手區/鹼性除菌清潔劑",
                  },
                  {
                    label: "泡沫去油清潔劑",
                    EN: "Foaming Degreasing Cleaner",
                    JP: "泡脱脂洗浄剤",
                    href: "/商品資訊/使用區域/加工|烹飪區/洗手區/泡沫去油清潔劑",
                  },
                  {
                    label: "強力去油清潔劑",
                    EN: "Heavy-duty Degreasing Cleaner",
                    JP: "強力脱脂洗浄剤",
                    href: "/商品資訊/使用區域/加工|烹飪區/洗手區/強力去油清潔劑",
                  },
                  {
                    label: "除菌漂白劑",
                    EN: "Antibacterial Bleach",
                    JP: "除菌漂白剤",
                    href: "/商品資訊/使用區域/加工|烹飪區/洗手區/除菌漂白劑",
                  },
                ],
              },
              {
                label: "擦拭布",
                EN: "Cleaning Cloths",
                JP: "清掃用クロス",
                href: "/商品資訊/使用區域/加工|烹飪區/擦拭布",
              },
              {
                label: "刷具",
                EN: "Brushes",
                JP: "ブラシ",
                href: "/商品資訊/使用區域/加工|烹飪區/刷具",
              },
              {
                label: "攪拌棒",
                EN: "Stirring Sticks",
                JP: "かき混ぜ棒",
                href: "/商品資訊/使用區域/加工|烹飪區/攪拌棒",
              },
            ],
          },
          {
            label: "包裝區",
            EN: "Packaging Area",
            JP: "包装エリア",
            href: "/商品資訊/使用區域/包裝區",
            children: [
              {
                label: "保鮮膜",
                EN: "Cling Film",
                JP: "ラップフィルム",
                href: "/商品資訊/使用區域/包裝區/保鮮膜",
              },
              {
                label: "食品包材",
                EN: "Food Packaging Materials",
                JP: "食品包装資材",
                href: "/商品資訊/使用區域/包裝區/食品包材",
              },
            ],
          },
          {
            label: "實驗/檢驗室(品管與食品安全檢測)",
            EN: "Laboratory / Inspection (QC & Food Safety Testing)",
            JP: "実験・検査室（品質管理・食品安全試験）",
            href: "/商品資訊/使用區域/實驗/檢驗室(品管與食品安全檢測)",
          },
          {
            label: "成品儲存區",
            EN: "Storage Area",
            JP: "製品保管エリア",
            href: "/商品資訊/使用區域/成品儲存區",
            children: [
              {
                label: "忌避劑",
                EN: "Insect Repellent",
                JP: "忌避剤",
                href: "/商品資訊/使用區域/成品儲存區/忌避劑",
              },
              {
                label: "防蟲/捕蟲燈(捕蟲紙)",
                EN: "Insect Light Traps (Sticky Boards)",
                JP: "防虫／捕虫ライト（粘着シート）",
                href: "/商品資訊/使用區域/成品儲存區/防蟲|捕蟲燈(捕蟲紙)",
              },
            ],
          },
          {
            label: "出貨區",
            EN: "Shipping Area",
            JP: "出荷エリア",
            href: "/商品資訊/使用區域/出貨區",
            children: [
              {
                label: "防撞桿",
                EN: "Crash Barriers",
                JP: "衝突防止バー",
                href: "/商品資訊/使用區域/出貨區/防撞桿",
              },
              {
                label: "區域標示",
                EN: "Area Signage",
                JP: "エリア表示",
                href: "/商品資訊/使用區域/出貨區/區域標示",
              },
              {
                label: "防護邊條",
                EN: "Protective Edge Guards",
                JP: "保護エッジ材",
                href: "/商品資訊/使用區域/出貨區/防護邊條",
              },
              {
                label: "快速捲門",
                EN: "High-speed Roll-up Doors",
                JP: "高速ロールアップドア",
                href: "/商品資訊/使用區域/出貨區/快速捲門",
              },
              {
                label: "防蟲門簾",
                EN: "Insect-screen Curtains",
                JP: "防虫カーテン",
                href: "/商品資訊/使用區域/出貨區/防蟲門簾",
              },
              {
                label: "忌避劑",
                EN: "Insect Repellent",
                JP: "忌避剤",
                href: "/商品資訊/使用區域/出貨區/忌避劑",
              },
              {
                label: "防蟲/捕蟲燈(捕蟲紙)",
                EN: "Insect Light Traps (Sticky Boards)",
                JP: "防虫／捕虫ライト（粘着シート）",
                href: "/商品資訊/使用區域/出貨區/防蟲|捕蟲燈(捕蟲紙)",
                children: [],
              },
            ],
          },
          {
            label: "廢棄物處理區",
            EN: "Waste Disposal Area",
            JP: "廃棄物処理エリア",
            href: "/商品資訊/使用區域/廢棄物處理區",
            children: [],
          },
          {
            label: "辦公區",
            EN: "Office Area",
            JP: "事務室",
            href: "/商品資訊/使用區域/辦公區",
            children: [],
          },
          {
            label: "洗手間",
            EN: "Restroom Area",
            JP: "お手洗い",
            href: "/商品資訊/使用區域/洗手間",
            children: [
              {
                label: "洗手設備",
                EN: "Handwashing Equipment",
                JP: "手洗い設備",
                href: "/商品資訊/使用區域/洗手間/洗手設備",
              },
              {
                label: "洗手液",
                EN: "Hand Soap",
                JP: "ハンドソープ",
                href: "/商品資訊/使用區域/洗手間/洗手液",
              },
              {
                label: "消毒液",
                EN: "Disinfectant",
                JP: "消毒液",
                href: "/商品資訊/使用區域/洗手間/消毒液",
              },
              {
                label: "擦手紙",
                EN: "Paper Towels",
                JP: "ペーパータオル",
                href: "/商品資訊/使用區域/洗手間/擦手紙",
              },
            ],
          },
        ],
      },

      {
        label: "專業諮詢",
        EN: "Professional Consultation",
        JP: "専門コンサルティング",
        href: "/商品資訊/專業諮詢(專人服務)",
      },
    ],
  },
  {
    label: "最新資訊",
    EN: "News",
    JP: "最新情報",
    href: "/最新資訊",
    children: [
      {
        label: "衛生知識專欄",
        EN: "Hygiene Articles",
        JP: "衛生知識コラム",
        href: "/最新資訊/衛生資訊/",
      },
      // {
      //   label: "活動資訊",
      //   EN: "Events & Activities",
      //   JP: "イベント情報",
      //   href: "/最新資訊/活動資訊/",
      // },
      {
        label: "最新消息",
        EN: "News",
        JP: "ニュース",
        href: "/最新資訊/最新消息",
      },
    ],
  },
  {
    label: "合作資訊",
    EN: "Contact",
    JP: "提携情報",
    href: "/合作資訊",
    children: [
      {
        label: "招募訊息",
        EN: "Careers",
        JP: "採用情報",
        href: "https://www.104.com.tw/company/1a2x6bjo7z?jobsource=index_s",
        external: true,
      },
      {
        label: "技術合作及聯合開發諮詢",
        EN: "Technical Collaboration & Development ",
        JP: "技術協業・共同開発に関するご相談",
        href: "/合作資訊/技術合作及聯合開發諮詢",
      },
    ],
  },
];

export default navConfigB2B;
